<template>
  <v-breadcrumbs divider=">" class="px-0 pt-0 breadcrumbs">
    <v-breadcrumbs-item
      v-for="(item, i) in items"
      :key="i"
      :class="[items.length > 1 ? 'cursor-point' : 'cursor-default']"
      @click.native="$emit('clickCrumb', item.id)"
    >
      <span class="text-breadcum-settings">
       {{ item.text }}
       <v-icon>mdi-chevron-right</v-icon>
      </span>
    </v-breadcrumbs-item>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: 'LocationsBreadcrumbs',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>

<style>
  .cursor-default {
    cursor: default;
  }
</style>
